/**
 * Token 统计页的标签色（antd 预设色名，不写色值）
 */

// 供应商成本表里的供应商标签
const PROVIDER_COLORS: Record<string, string> = {
  openai: 'blue',
  anthropic: 'green',
  google: 'orange',
  alibaba: 'cyan',
  cerebras: 'purple',
  xai: 'magenta',
  deepseek: 'geekblue',
  baidu: 'volcano',
  阿里百练: 'cyan'
}

// 明细表里的供应商标签（旧版用另一套配色，保持一致）
const DETAIL_PROVIDER_COLORS: Record<string, string> = {
  OPENAI: 'green',
  ANTHROPIC: 'blue',
  GOOGLE: 'orange',
  ALIBABA: 'cyan',
  CEREBRAS: 'purple',
  XAI: 'magenta',
  DEEPSEEK: 'geekblue',
  BAIDU: 'red',
  'OPENAI-4.1': 'lime',
  阿里百练: 'cyan'
}

// 前三名高亮（旧版写的 silver / bronze 不是 antd 预设色，改用预设色）
const RANK_COLORS = ['gold', 'blue', 'orange']

export function providerColor(provider: string): string {
  return PROVIDER_COLORS[provider?.toLowerCase()] || 'default'
}

export function detailProviderColor(provider: string): string {
  return DETAIL_PROVIDER_COLORS[provider?.toUpperCase()] || 'default'
}

export function rankColor(index: number): string {
  return RANK_COLORS[index] ?? 'default'
}
